import dayjs from "dayjs";

export default (newDate: string, currentDate: Date): Date => {
  const formatedNewDate = dayjs(newDate);
  const newHour = formatedNewDate.hour();
  const newMinute = formatedNewDate.minute();

  return dayjs(currentDate).hour(newHour).minute(newMinute).second(0).toDate();
};
